export const SHOW_ONLINETEST_RESULT_REQUIST = "SHOW_ONLINETEST_RESULT_REQUIST";
export const SHOW_ONLINETEST_RESULT_SUCCESS = "SHOW_ONLINETEST_RESULT_SUCCESS";
export const SHOW_ONLINETEST_RESULT_FAIELD = "SHOW_ONLINETEST_RESULT_FAIELD";
